import React, { useState, useEffect, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useNavigate } from "react-router-dom";
import '@css/company-login.css';
import axiosInstance from '@utils/axiosInstance';
import { setMessage } from '@store/messageSlice';
import { useDispatch } from 'react-redux';

export default function CompanyLogIn() {

  const buttonRef = useRef();
  const [companyCode, setCompanyCode] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    //일단 율도 밖에 없어서 주석 처리
    // const companyCode = localStorage.getItem("companyCode");
    // if (companyCode) {
    //   navigate("/login");
    // }

    navigate("/login");

  }, []);

  const handleCompanyCodeChange = (e) => {
    setCompanyCode(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      buttonRef.current.click();
    }
  }

  const OnClickNext = async () => {


    try {
      const response = await axiosInstance.get(`/api/auth/checkCompanyCode/` + companyCode);

      if (response.data === true) {
        localStorage.setItem("companyCode", companyCode);
        navigate('/login');
      }
      
    } catch (error) {
      console.log(error);
    }

  }

  return (
    <div className="login-container">
      <h1 style={{ marginBottom: '70px' }}>로그인</h1>
      <input id="nl-id"
        className="form-control"
        placeholder="회사 코드를 입력 해 주세요."
        value={companyCode}
        onChange={handleCompanyCodeChange}
        onKeyDown={handleKeyDown}
      />
      <button id="nl-next" type="button" className="btn btn-primary btn-lg" ref={buttonRef} onClick={OnClickNext}>다음</button>
    </div>
  );
}